<template>
  <div id="passions" class="bg-primary">
    <div class="passion-cards">
      <div
        v-for="(card, index) in passionCards"
        :class="['card', index === cardIndex ? 'active' : '']"
        :key="index"
        @click="showHide(index)"
        @mouseleave="cardIndex = null"
      >
        <div class="card-header">
          <h4>{{ card.title }}</h4>
          <span class="icon" v-html="card.icon"></span>
        </div>
        <div class="card-info" v-if="index === cardIndex">
          <div class="card-body">
            <p v-html="card.bodyText"></p>
          </div>
          <div class="card-quote txt-right">
            <p class="body">{{ card.bodyQuote }}</p>
            <small class="who">- {{ card.quoteAuthor }} -</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Passions",
  data() {
    return {
      passionCards: [
        {
          title: "CODICE",
          icon: `
          <svg
            height="80px"
            viewBox="0 0 166 130"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xml:space="preserve"
            xmlns:serif="http://www.serif.com/"
            style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
          >
            <g>
              <path
                d="M94.013,114.593l8.531,12.655"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
              <path
                d="M111.849,127.464l-58.017,-0"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
              <path
                d="M71.668,114.593l-8.531,12.655"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
            </g>
            <path
              d="M164.052,85.711l-162.302,0"
              style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
            />
            <g>
              <path
                d="M113.5,37.1l-7.588,7.588l7.675,7.675"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
              <path
                d="M141.157,37.1l7.588,7.588l-7.675,7.675"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
              <path
                d="M132.188,32.054l-10.857,25.354"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
            </g>
            <g>
              <path
                d="M20.535,20.156l14.019,0"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
              <path
                d="M20.535,29.005l31.233,-0"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
              <path
                d="M20.535,44.373l21.485,0"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
              <path
                d="M20.535,53.925l13.797,0"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
              <path
                d="M20.535,69.306l12.528,0"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
              <path
                d="M34.141,54.194l13.859,-0"
                style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
              />
            </g>
            <path
              d="M163.671,12.407c0,-5.882 -4.775,-10.657 -10.657,-10.657l-140.347,-0c-5.882,-0 -10.657,4.775 -10.657,10.657l-0,89.963c-0,5.882 4.775,10.657 10.657,10.657l140.347,0c5.882,0 10.657,-4.775 10.657,-10.657l0,-89.963Z"
              style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
            />
            <path
              d="M83.372,15.365l-0,58.733"
              style="fill:none;stroke:#15e8ff;stroke-width:3.5px;"
            />
            <path
              d="M76.941,98.763l5.167,0l-0,8.943c-0,-0 7.425,-0.057 7.735,-7.488c0.268,-6.427 -4.953,-7.62 -7.867,-7.62l-8.814,0"
              style="fill:none;stroke:#15e8ff;stroke-width:1.5px;"
            />
            <circle cx="81.997" cy="95.738" r="0.93" style="fill:#15e8ff;" />
          </svg>
          `,
          bodyText:
            "Grazie alla dislessia, da sempre mia compagna fedele, ho imparato a superare con molta determinazione tutti gli ostacoli. La tecnologia e l’informatica hanno contribuito positivamente in questo percorso, spingendomi così a cercare di comprendere ed approfondire gli strumenti dispensativi.",
          bodyQuote:
            "Non importa quante volte devo fare clic, purchè ciascun clic sia frutto di una scelta semplice e non ambigua",
          quoteAuthor: "Seconda legge di Krug sull’usabilità"
        },
        {
          title: "DESIGN",
          icon: `
           <svg
            height="80px"
            viewBox="0 0 28 33"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xml:space="preserve"
            xmlns:serif="http://www.serif.com/"
            style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
          >
            <path
              d="M3.143,23.868c0.982,0.713 2.339,1.768 2.339,2.929l0,0.062c0,3.695 0.412,5.326 4.385,5.326l7.593,0c3.974,0 4.643,-1.631 4.643,-5.326l0,-0.062c0,-1.161 1.357,-2.216 2.34,-2.929c2.149,-1.561 2.768,-2.622 2.768,-5.348l-0,-12.935c-0,-3.686 -1.741,-5.21 -5.693,-5.21l-15.45,-0c-3.952,-0 -5.693,1.524 -5.693,5.21l0,12.935c0,2.726 0.619,3.787 2.768,5.348"
              style="fill:none;fill-rule:nonzero;stroke:#15e8ff;stroke-width:0.75px;"
            />
            <path
              d="M15.821,26.721l0,-14.645c0,-0.415 0.336,-0.75 0.75,-0.75l1.519,0c0.414,0 0.75,0.335 0.75,0.75l0,1.661c0,0.414 -0.336,0.75 -0.75,0.75l-8.478,0c-0.415,0 -0.75,-0.336 -0.75,-0.75l0,-1.661c0,-0.415 0.335,-0.75 0.75,-0.75l1.621,0c0.414,0 0.75,0.335 0.75,0.75l-0,14.645"
              style="fill:none;fill-rule:nonzero;stroke:#15e8ff;stroke-width:0.75px;stroke-linejoin:miter;stroke-miterlimit:10;"
            />
            <path
              d="M22.334,25.758c-0.016,0.127 -0.032,0.497 -0.025,0.793c0,0 -8.172,1.849 -17.042,-0.105c0,0 0.019,-0.583 -0.046,-0.816c-0,-0 7.565,1.921 17.113,0.128Z"
              style="fill:#15e8ff;"
            />
            <path
              d="M22.281,27.537c-0.004,0.148 -0.026,0.492 -0.069,0.798c0,-0 -8.004,1.845 -16.874,-0.109c-0,0 -0.031,-0.331 -0.049,-0.816c-0,0 7.444,1.921 16.992,0.127Z"
              style="fill:#15e8ff;"
            />
            <path
              d="M22.054,29.316c-0.025,0.113 -0.139,0.503 -0.281,0.785c0,-0 -7.328,1.83 -16.098,-0.102c0,-0 -0.123,-0.26 -0.225,-0.808c0,0 7.163,1.898 16.604,0.125Z"
              style="fill:#15e8ff;"
            />
          </svg>
          `,
          bodyText:
            "Il design, come la programmazione, è un mondo in continua crescita, che non si ferma mai. Un buon design non solo crea un buon prodotto, ma lo rende semplice e funzionale. Insieme alla programmazione e allo studio, le letture sul design mi hanno sempre più spinto a semplificare i miei lavori, pur mantenendo un bell'aspetto e funzionale.",
          bodyQuote: "La semplicità è la complessità risolta",
          quoteAuthor: "Bruno Munari"
        },
        {
          title: "FITNESS",
          icon: `
           <svg
            height="80px"
            viewBox="0 0 171 136"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xml:space="preserve"
            xmlns:serif="http://www.serif.com/"
            style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
          >
            <path
              d="M73.808,133.776c0,-0 -2.098,-4.917 -6.417,-7.47c-0,0 2.66,-8.098 -5.32,-23.398c-0.417,-0.285 -3.679,-4.889 -4,-5.263c-0.902,-1.049 -1.882,-3.437 -2.486,-4.65c-1.003,-2.014 -1.905,-5.196 -2.29,-7.379c-0.58,-3.283 0.808,-5.804 -0.58,-8.88c-1.368,-3.032 -4.974,-4.753 -7.216,-7.318c-1.808,-2.069 -3.409,-4.288 -4.908,-6.551c-3.309,-4.994 -2.185,-10.911 -5.46,-16.102c-1.753,-2.778 -4.018,-5.279 -5.67,-8.108c-5.637,-9.659 -5.384,-11.466 -9.47,-21.417c-0.736,-1.792 -1.47,-3.597 -2.454,-5.289c-0.92,-1.582 -2.713,-2.772 -3.107,-4.63c-1.126,-5.316 6.005,-7.334 10.34,-4.612c2.319,1.456 1.36,8.521 1.497,8.97c0.896,2.601 1.804,5.238 3.263,7.618c4.384,7.149 10.577,11.393 12.452,19.885c0,0 13.267,7.657 13.759,18.375c0,0 15.9,2.203 18.084,10.999c-0,-0 4.897,4.687 2.992,-9.255c-0.624,-1.403 -1.25,-2.811 -1.705,-4.266c-0.431,-1.379 -0.799,-2.787 -0.944,-4.215c-0.531,-5.255 2.289,-16.987 11.508,-16.987c0.211,-0 2.56,-0.093 4.371,0.932c5.48,3.103 7.322,10.819 6.793,16.055c-0.145,1.428 -0.513,2.836 -0.944,4.215c-0.455,1.455 -1.081,2.863 -1.705,4.266c-1.905,13.942 2.992,9.255 2.992,9.255c2.184,-8.796 18.084,-10.999 18.084,-10.999c0.492,-10.718 13.759,-18.375 13.759,-18.375c1.875,-8.492 8.068,-12.736 12.452,-19.885c1.459,-2.38 2.367,-5.017 3.263,-7.618c0.137,-0.449 -0.822,-7.514 1.497,-8.97c4.335,-2.722 11.466,-0.704 10.34,4.612c-0.398,1.879 -2.18,3.011 -3.12,4.627c-0.984,1.691 -1.715,3.497 -2.441,5.292c-4.277,10.57 -3.528,11.367 -9.47,21.417c-1.668,2.821 -3.917,5.33 -5.67,8.108c-3.275,5.191 -2.151,11.108 -5.46,16.102c-1.499,2.263 -3.1,4.482 -4.908,6.551c-2.242,2.565 -5.848,4.286 -7.216,7.318c-1.388,3.076 -0,5.597 -0.58,8.88c-0.385,2.183 -1.287,5.365 -2.29,7.379c-0.604,1.213 -1.584,3.601 -2.486,4.65c-0.321,0.374 -3.583,4.978 -4,5.263c-7.98,15.3 -5.32,23.398 -5.32,23.398c-4.319,2.553 -6.417,7.47 -6.417,7.47l-23.392,-0Z"
              style="fill:none;stroke:#00ecff;stroke-width:3px;"
            />
            <path
              d="M156.575,4.097l10.867,0l1.13,0.003l-0,6.47l-13.426,-0"
              style="fill:none;stroke:#00ecff;stroke-width:3px;"
            />
            <path
              d="M144.407,10.54l-117.869,-0"
              style="fill:none;stroke:#00ecff;stroke-width:3px;"
            />
            <path
              d="M16.002,10.541l-14.502,-0l0,-6.408l12.942,0"
              style="fill:none;stroke:#00ecff;stroke-width:3px;"
            />
            <path
              d="M26.126,4.119l118.806,0"
              style="fill:none;stroke:#00ecff;stroke-width:3px;"
            />
          </svg>
          `,
          bodyText:
            "Lo sport mi ha accompagnato lungo tutto il mio percorso e mi ha aiutato ad affrontare le difficoltà, a rialzarmi ogni qualvolta cadevo e a non mollare mai, superando i propri obiettivi. Pratico il Calisthenics e, come nella programmazione, non c’è un punto di arrivo, ma solo un continuo miglioramento; ci sono delle <em> skills </em> da apprendere e superare.",
          bodyQuote: "La crescita non è fatta di sole carezze. ",
          quoteAuthor: "Massimo Mascioletti"
        }
      ],
      cardIndex: null
    };
  },
  methods: {
    showHide(index) {
      if (index === this.cardIndex) {
        this.cardIndex = null;
      } else {
        this.cardIndex = index;
      }
    }
  }
};
</script>

<style lang="scss">
#passions {
  @include d-flex("center");
  background-image: url("~@/img/passion-bg.jpg");
  background-size: cover;
  background-position: center;
  background-blend-mode: soft-light;
  height: 100vh;
  .passion-cards {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    text-align: center;
    .card {
      position: relative;
      display: flex;
      height: 150px;
      flex-direction: column;
      justify-content: flex-start;
      width: 100%;
      padding: 2rem;
      background: rgba(51, 51, 51, 0.35);
      filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.4));
      cursor: pointer;
      transition: height 350ms ease;
      svg {
        height: 55px;
        transition: all 350ms ease;
      }
      h4 {
        margin-bottom: 1rem;
        transition: all 350ms ease;
      }
      .card-header {
        width: 100%;
      }
      .card-body {
        p {
          font-size: 1rem;
          line-height: 1.3rem;
          margin-top: 2rem;
          padding: 0 5px;
        }
      }
      .card-info {
        height: 0;
        overflow: hidden;
        transition: all 350ms ease;
      }
      .card-quote {
        align-self: flex-end;
        font-family: $serif;
        margin-top: 25px;
        position: absolute;
        opacity: 0;
        right: 20px;
        bottom: 20px;
        transition: opacity 200ms linear;
        p {
          line-height: 1rem;
          padding: 0 10px;
          color: palette(4);
          font-family: $serif;
        }
      }
      &.active {
        @include d-flex("center");
        position: absolute;
        bottom: 50%;
        transform: translateY(50%);
        height: 70%;
        max-height: 80%;
        width: 100%;
        z-index: 1;
        background: rgba(palette(2), 0.95);
        .card-info {
          height: 200px;
          overflow-y: auto;
        }
        .card-quote {
          opacity: 1;
        }
        svg {
          height: 85px;
          transition: all 350ms ease;
        }
        h4 {
          height: 0;
          overflow: hidden;
        }
      }
    }
  }
}

@media screen and (min-width: 768px) {
  #passions {
    .passion-cards {
      flex-direction: row;
      .card {
        height: 220px;
        width: calc(100% / 3);
        padding: 2rem 3rem;
        transition: all 350ms ease;
        svg {
          height: auto;
          transition: all 350ms ease;
        }
        h4 {
          font-size: 2.5rem;
          margin-bottom: 2rem;
          transition: all 350ms ease;
        }
        .card-info {
          display: flex;
          flex-direction: column;
          border-radius: 0;
          height: 0;
          overflow: hidden;
          transition: all 350ms ease;
        }
        .card-body {
          flex-direction: column;
          justify-content: space-between;
          text-align: left;
          margin: 2rem 0 2.5rem;
          p {
            margin-top: 0;
            line-height: 1.5rem;
            font-size: 1rem;
          }
        }
        &.active {
          position: relative;
          left: 0;
          top: 0;
          height: 450px;
          width: calc(100% / 3);
          transform: translate(0, 0);
          border-radius: 20px;
          display: flex;
          background: rgba(51, 51, 51, 0.45);
          .card-info {
            height: 100%;
          }
        }
        &:hover:not(.active) {
          h4 {
            transform: translateY(-35px) rotateX(90deg);
          }
          svg {
            transform: translateY(-35px) scale(1.25);
          }
        }
      }
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1450px) {
  #passions {
    .passion-cards {
      .card {
        .card-body {
          p {
            font-size: 0.9rem;
            line-height: 1.3rem;
            height: 185px;
            overflow: auto;
          }
        }
      }
    }
  }
}

@media screen and (max-height: 650px) {
  #passions {
    .passion-cards {
      .card {
        &.active {
          h4 {
            display: none;
          }
          svg {
            height: 50px;
          }
          .card-info {
            height: 75%;
            margin-bottom: 50px;
          }
        }
      }
    }
  }
}
</style>
